/*
 * Componente de paginado
 *
 * Componente que se aplica a las tablas para mostrar el paginado y tener el control
  * de la página actual y los elementos por página.
 *
 * Created on Thu Jul 13 2023 by José Luis Chávez Ayala.
 *
 * Copyright (c) 2023 Turn My App.
 */

<template>
  <div>
    <!-- #region::Pagination & items per list -->
    <b-row align-h="between">

      <!-- #region::Items per list -->
      <b-col :md="perPageCol">
        <b-form-group
          class="mb-0"
        >
          <label class="d-inline-block text-sm-left mr-50">Por página</label>
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            :options="pageOptions"
            class="w-50"
            @change="handleChangeItemsPerPage"
          />
        </b-form-group>
      </b-col>
      <!-- #endregion::Items per list -->

      <!-- #region::Pagination -->
      <b-col
        cols="12"
        md="auto"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
          align="right"
          class="my-1 my-md-0 pagination-secondary"
          @change="handleChangePage"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </b-col>
      <!-- #endregion::Pagination -->

    </b-row>
    <!-- #endregion::Pagination & items per list -->

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  BRow, BCol, BPagination, BFormGroup, BFormSelect,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BPagination,
    BFormSelect,
  },
  props: {
    /**
     * Función que se ejecuta cuando se cambia de página o de items por página
     */
    callback: {
      type: Function,
      required: true,
    },
    /**
     * Número total de filas
     */
    totalRows: {
      type: Number,
      required: true,
    },
    /**
     * Indica si se puede aplicar la paginación global
     */
    canApplyGlobalPagination: {
      type: Boolean,
      default: true,
    },
    /**
     * Número de columnas para el select de elementos por página
     */
    perPageCol: {
      type: Number,
      default: 2,
    },
    /**
     * Número de registros por página para ecommerce
     */
    module: {
      type: String,
      default: '',
    },
    defaultPerPage: {
      type: Number,
      default: 10,
    },
  },
  data(props) {
    return {
      perPage: props.defaultPerPage,
      currentPage: 1,
      pageOptions: props.module === 'ecommerce' ? [10, 30, 50] : [3, 5, 10],
    }
  },
  computed: {
    ...mapGetters({
      getFilteredPerPage: 'filters/getFilteredPerPage',
      getFilteredCurrentPage: 'filters/getFilteredCurrentPage',
    }),
    /**
     * Indica la cantidad de elementos por página (paginado global)
     */
    filteredPerPage: {
      get() { return this.getFilteredPerPage },
    },
    /**
     * Indica la página actual (paginado global)
     */
    filteredCurrentPage: {
      get() { return this.getFilteredCurrentPage },
    },
  },
  /**
  * Hook de creación del componente
  * @summary Verifica si se puede aplicar la paginación global
  */
  created() {
    if (this.canApplyGlobalPagination) {
      this.perPage = this.filteredPerPage
      this.currentPage = this.filteredCurrentPage
    }
  },
  methods: {
    /**
    * Cambio de página
    * @summary Atiente el evento de cambio de página
    * @param {Number} currentPage - Página actual
    */
    handleChangePage(currentPage) {
      this.currentPage = currentPage
      this.callback(currentPage, this.perPage)
    },

    /**
    * Elementos por página
    * @summary Escucha el evento de cambio de elementos por página
    * @param {Number} perPage - Elementos por página
    */
    handleChangeItemsPerPage(perPage) {
      this.perPage = perPage
      this.callback(this.currentPage, perPage)
    },

    /**
    * Restablece la página actual
    * @summary Método llamado por los componentes de listas para restablecer la página
    * @param {Number} numberPage - Número de página a restablecer
    */
    resetCurrentPage(numberPage = 1) {
      this.currentPage = numberPage
    },

    /**
    * Restablece la página actual
    * @summary Método llamado por los componentes de listas para restablecer la página
    * @param {Number} numberPage - Número de página a restablecer
    */
    resetPerPage(perPage = 10) {
      this.perPage = perPage
    },
  },
}
</script>
